import React, { useState } from 'react';
import "../styles/Facilities.css";

const Facilities = () => {
  const [expandedCard, setExpandedCard] = useState(null);
   const facilities = [
    {
      id: 1,
      title: "Screening & Testing Lab",
      icon: "🔬",
      image: "screening-lab.jpg",
      shortDesc: "State-of-the-art screening for infectious markers and blood grouping.",
      fullDesc: "Our advanced laboratory uses cutting-edge technology to screen for infectious diseases including HIV, Hepatitis B & C, Syphilis, and Malaria. Each unit is tested with strict quality control measures."
    },
    {
      id: 2,
      title: "Cold Storage",
      icon: "❄️",
      image: "cold-storage.jpg",
      shortDesc: "Temperature-controlled storage to preserve blood components safely.",
      fullDesc: "Our blood bank maintains multiple temperature zones: +2 to +6°C for red cells, +20 to +24°C for platelets, and -30°C for plasma, ensuring optimal preservation of all blood components."
    },
    {
      id: 3,
      title: "Donor Counselling",
      icon: "💬",
      image: "counselling.jpg",
      shortDesc: "Pre- and post-donation counselling to ensure donor safety and awareness.",
      fullDesc: "Our trained counsellors provide confidential guidance before and after donation, explaining the process, addressing concerns, and ensuring donor wellbeing throughout the experience."
    },
    {
      id: 4,
      title: "Blood Donation",
      icon: "🩸",
      image: "blood-donation.jpg",
      shortDesc: "Open daily from 8 AM to 8 PM for voluntary blood donation.",
      fullDesc: "Our blood centre welcomes eligible donors every day from 8 AM to 8 PM. Walk-ins are welcome, and appointments can be scheduled for your convenience. Each donation saves up to 3 lives."
    },
    {
      id: 5,
      title: "Raktadoot Seva",
      icon: "🚑",
      image: "raktadoot.jpg",
      shortDesc: "Doorstep blood delivery with trained courier team.",
      fullDesc: "Experience seamless doorstep blood delivery with our trained 10-member team, ensuring safe, timely, and monitored transport of blood — so patients' families can stay stress-free during critical times."
    },
    {
      id: 6,
      title: "Platelet Donation",
      icon: "🧬",
      image: "platelet.jpg",
      shortDesc: "Single Donor Platelets (SDP) available every day.",
      fullDesc: "Our Blood Centre is equipped to prepare Single Donor Platelets (SDP) using advanced technology, ensuring their availability every day for cancer patients and those with low platelet counts."
    },
    {
      id: 7,
      title: "Blood Donor Test Report",
      icon: "📋",
      image: "test-report.jpg",
      shortDesc: "Access your test reports within 10 days of donation.",
      fullDesc: "Blood donors can access their test reports within 10 days of donation. To receive the report, donors can either send a request from their registered email ID or visit the Blood Centre in person with a valid government ID and prior appointment."
    },
    {
      id: 8,
      title: "Blood Group Confirmation",
      icon: "🩺",
      image: "blood-group.jpg",
      shortDesc: "Reliable blood group confirmation with advanced technology.",
      fullDesc: "Our Blood Centre provides reliable blood group confirmation services. Each test is performed using advanced technology and strict quality standards. Donors and patients receive accurate results within a short time."
    },
    {
      id: 9,
      title: "Blood Component Separation",
      icon: "⚗️",
      image: "component-separation.jpg",
      shortDesc: "Advanced leucoreduction technology for safer transfusions.",
      fullDesc: "At our centre, blood components are separated using leucoreduction technology. This removes unwanted white cells, ensuring safer and more effective transfusions. High-speed centrifuges and automated extractors preserve plasma quality for patient benefit."
    },
    {
      id: 10,
      title: "Cross Matching",
      icon: "🔍",
      image: "cross-matching.jpg",
      shortDesc: "Vital compatibility test before transfusion (45-60 min).",
      fullDesc: "Cross matching is a vital test performed before any blood transfusion to ensure that the donor's blood is fully compatible with the recipient's. The process generally takes 45 minutes to 1 hour. During the test, the patient's blood is carefully mixed with the donor's and incubated at 37°C, mimicking body temperature."
    }
  ];

  const toggleCard = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };


  return (
    <div className="facilities-page">
      <section className="hero">
        <h2>Our Facilities</h2>
        <p>
          We maintain modern facilities to ensure safe collection, testing, and
          storage of blood.
        </p>
      </section>

    <main className="container-facility">
      <div className="grid-facility">
        {facilities.map((facility) => (
          <div
            key={facility.id}
            className={`facility-card ${expandedCard === facility.id ? 'expanded' : ''}`}
            onClick={() => toggleCard(facility.id)}
          >
            <div className="facility-image-wrapper">
              <img src={facility.image} alt={facility.title} className="facility-image" />
              <div className="facility-icon">{facility.icon}</div>
            </div>
            <div className="facility-content">
              <h4>{facility.title}</h4>
              <p className="short-desc">{facility.shortDesc}</p>
              {expandedCard === facility.id && (
                <p className="full-desc">{facility.fullDesc}</p>
              )}
              <button className="read-more-btn">
                {expandedCard === facility.id ? 'Show Less ▲' : 'Read More ▼'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </main>
    </div>
  );
};

export default Facilities;
